import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

declare global {
  interface Window {
    __FIREBASE_DEFAULTS__?: object;
  }
}

/**
 * Firebase reads SDK defaults, including emulator hosts, from this global before falling back to a
 * `__FIREBASE_DEFAULTS__=` cookie. That cookie lookup also matches the marker inside another cookie's
 * value, such as a GTM linker cookie set from a URL, which would let a link send ID tokens to an
 * attacker's "emulator". Setting the global first means the cookie is never read. Must run before
 * `getAuth` and `getStorage`. See H1 #4101898.
 */
window.__FIREBASE_DEFAULTS__ = {};

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const firebase = initializeApp(firebaseConfig);

const auth = getAuth(firebase);
auth.settings.appVerificationDisabledForTesting = false;
const storage = getStorage(firebase);

export { firebase, auth, storage, firebaseConfig };
